import { Awareness } from 'y-protocols/awareness'

export const mergeupdateAndBroadcastAwareness = (awareness: Awareness, data: Record<string, unknown>): void =>
  awareness.setLocalState({
    ...awareness.getLocalState(),
    ...data,
  })
